"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const moment_1 = __importDefault(require("moment"));
function default_1({ confirm, errorCode, errorReason, }) {
    const yymmdd = (0, moment_1.default)().format('YYMMDD');
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('화면을 캡쳐하여 1:1 문의하기 해주세요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('접수 번호')}: ${yymmdd}${errorCode !== null && errorCode !== void 0 ? errorCode : ''}${errorReason || ''}`] })),
        confirmationText: i18next_1.default.t('1:1 문의하기'),
    })
        .then(() => (window.location.href = '/fondee/qna'))
        .catch(() => { });
}
exports.default = default_1;
